import {importSwiper} from "./kp-util";

const blocks = document.querySelectorAll('.block--testimonial-carousel')

if (blocks.length > 0) {
    importSwiper().then(({Swiper, Navigation, Autoplay}) => {
        blocks.forEach(block => {

            const carousel = block.querySelector('.swiper-image-carousel')
            const next = block.querySelector('.swiper-button-next')
            const prev = block.querySelector('.swiper-button-prev')

            new Swiper(carousel, {
                modules: [Navigation, Autoplay],
                slidesPerView: 1.1,
                spaceBetween: 16,
                loop: true,
                autoplay: false,
                delay: 6000,
                centeredSlides: true,
                simulateTouch: true,
                navigation: {nextEl: next, prevEl: prev},
                breakpoints: {768: {slidesPerView: 2, centeredSlides: false, simulateTouch: false, spaceBetween: 32}, 1024: {slidesPerView: 3}}
            })
        })
    })
}

